// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { Contract } from 'model/Contract';

// The print address already contains name and country; without it, fall back to the single fields.
// The contact is always the end customer, so an unresolved name falls back to the end customer number.
export function contactLines(contract: Contract): string[] {
  const lines =
    contract.contactAddressLines && contract.contactAddressLines.length > 0
      ? [...contract.contactAddressLines, contract.contactEmail]
      : [contract.contactName || contract.endCustomerNumber, contract.contactCountry, contract.contactEmail];
  return lines.filter((line): line is string => !!line);
}
